/* eslint-disable no-unused-vars */
import Vue from 'vue'
import App from './App'
import router from './router'
import { store } from './store'
import Buefy from 'buefy'
import Toasted from 'vue-toasted'
import VueGeolocation from 'vue-browser-geolocation'
import AOS from 'aos'
import SocialSharing from 'vue-social-sharing'
import VueTheMask from 'vue-the-mask'
import VueCurrencyInput from 'vue-currency-input'
import { auth } from './firebaseConfig'
import './vee-validate'
import '@mdi/font/css/materialdesignicons.css'
import 'buefy/dist/buefy.css'
import './assets/scss/app.scss'
import './assets/scss/tailwind.scss'
import 'aos/dist/aos.css'

const pluginOptions = {
  globalOptions: {
    currency: 'BRL',
    locale: 'pt-BR'
  }
}

Vue.use(VueCurrencyInput, pluginOptions)
Vue.use(Toasted, { className: 'toast', duration: 3000 })
Vue.use(Buefy)
Vue.use(VueGeolocation)
Vue.use(SocialSharing)
Vue.use(VueTheMask)

Vue.config.productionTip = false

// handle page reloads
let app
auth.onAuthStateChanged(user => {
  if (!app) {
    app = new Vue({
      created () {
        AOS.init()
      },
      el: '#app',
      router,
      store,
      render: h => h(App)
    })
  }
})
